import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text, XStack, YStack } from 'tamagui';
import { GradientButton } from 'tamagui-config';

import { StyledCard } from './styles';
import { TimeInput } from './TimeInput';
import { FormField } from '../index';

type BaseStationAddressSectionProps = {
  addressValue: string;
  cityValue: string;
  zipValue: string;
  stateValue: string;
  isSaving?: boolean;
  onFocus: (field: FormField) => void;
  onChange: (field: FormField, value: string) => void;
  onSave: () => void;
};

export const BaseStationAdressSection: React.FC<BaseStationAddressSectionProps> = ({
  addressValue,
  cityValue,
  zipValue,
  stateValue,
  isSaving,
  onFocus,
  onChange,
  onSave,
}) => {
  const { t } = useTranslation();

  return (
    <StyledCard height={432} width={600} justifyContent="space-between">
      <YStack gap="$5">
        <Text color="white12" fontFamily="$heading" fontSize="$6" fontWeight="$5">
          {t('settings.general.baseStationAddress')}
        </Text>
        <YStack gap="$5">
          <TimeInput
            placeholder={t('settings.general.street')}
            value={addressValue}
            onFocus={() => onFocus(FormField.Street)}
            onChangeText={(val) => onChange(FormField.Street, val)}
          />
          <XStack gap="$5">
            <TimeInput
              placeholder={t('settings.general.city')}
              value={cityValue}
              onFocus={() => onFocus(FormField.City)}
              onChangeText={(val) => onChange(FormField.City, val)}
            />
            <TimeInput
              placeholder={t('settings.general.zip')}
              value={zipValue}
              onFocus={() => onFocus(FormField.Zip)}
              onChangeText={(val) => onChange(FormField.Zip, val)}
            />
            <TimeInput
              placeholder={t('settings.general.state')}
              value={stateValue}
              onFocus={() => onFocus(FormField.State)}
              onChangeText={(val) => onChange(FormField.State, val)}
            />
          </XStack>
        </YStack>
      </YStack>
      <XStack justifyContent="flex-end">
        <GradientButton
          rounded
          height={72}
          paddingHorizontal="$5"
          fontSize="$8.5"
          fontWeight="$4"
          loading={isSaving}
          onPress={onSave}>
          {t('common.save')}
        </GradientButton>
      </XStack>
    </StyledCard>
  );
};
